// src/app/hooks/useViewportInsets.ts
import { useState, useEffect, useCallback } from 'react';

export interface SafeAreaInsets {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export interface ViewportInsets {
  contentInsets: SafeAreaInsets;
  systemInsets: SafeAreaInsets;
}

function getInsets(): SafeAreaInsets {
  try {
    const tg = (window as any).Telegram?.WebApp;
    if (!tg) return { top: 0, bottom: 0, left: 0, right: 0 };
    // Современный источник
    if (tg.viewportSafeAreaInsets) {
      return { ...tg.viewportSafeAreaInsets };
    }
    // Устаревший fallback
    if (tg.safeAreaInset) {
      return { ...tg.safeAreaInset };
    }
    return { top: 0, bottom: 0, left: 0, right: 0 };
  } catch {
    return { top: 0, bottom: 0, left: 0, right: 0 };
  }
}

export function useViewportInsets(): ViewportInsets {
  const [systemInsets, setSystemInsets] = useState<SafeAreaInsets>(getInsets);

  const updateInsets = useCallback(() => {
    setSystemInsets(getInsets());
  }, []);

  useEffect(() => {
    updateInsets();
    const tg = (window as any).Telegram?.WebApp;
    if (!tg) return;

    if (typeof tg.onEvent === 'function') {
      tg.onEvent('viewportChanged', updateInsets);
    }
    const interval = setInterval(updateInsets, 500);

    return () => {
      if (typeof tg.offEvent === 'function') {
        tg.offEvent('viewportChanged', updateInsets);
      }
      clearInterval(interval);
    };
  }, [updateInsets]);

  return {
    contentInsets: systemInsets,
    systemInsets,
  };
}